import { clsx } from 'clsx';
import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/icons/Icon';
import { refinancePhoto } from '@/assets/images/offer';
import { formatAmountWithSpaces } from '@/lib/amountUtils';
import styles from './RefinanceBanner.module.scss';

const MAX_AMOUNT = 12000;

interface RefinanceBannerProps {
  trackingId: string;
  onClick: () => void;
}

function RefinanceCard({ className }: { className?: string }) {
  return (
    <div className={clsx(styles.card, className)}>
      <img src={refinancePhoto} alt="" className={styles.photo} />
      <div className={styles.cardHeader}>
        <p className={styles.cardTitle}>Refinanțare</p>
        <span className={styles.badge}>Smart</span>
      </div>
      <div className={styles.cardBalance}>
        <p className={styles.cardLabel}>Până la</p>
        <p className={styles.cardSum}>
          <span className={styles.cardAmount}>
            {formatAmountWithSpaces(MAX_AMOUNT)}
          </span>
          <span className={styles.cardCurrency}>lei</span>
        </p>
      </div>
    </div>
  );
}

export function RefinanceBanner({ trackingId, onClick }: RefinanceBannerProps) {
  return (
    <div className={styles.root}>
      <div className={styles.box}>
        <div className={styles.visual} aria-hidden>
          <RefinanceCard className={styles.cardBack} />
          <RefinanceCard className={styles.cardFront} />
        </div>
        <div className={styles.text}>
          <p className={styles.title}>Refinanțează</p>
          <p className={styles.description}>și primește bani în plus!</p>
        </div>
        <Button
          trackingId={trackingId}
          variant="tonal"
          size="medium"
          color="primary"
          text="Vezi detalii și beneficii"
          rightIcon={<Icon name="arrow-right" />}
          onClick={onClick}
          className={styles.button}
        />
      </div>
    </div>
  );
}
